// Konfiguration der Getränkerechner-Landingpages. Ein Tool, mehrere
// Keyword-Einstiege. Geteilt von React-Pages und scripts/prerender.js.
export const GETRAENKE_SEITEN = [
  {
    slug: "getraenke-pro-person-party",
    title: "Getränke pro Person für die Party berechnen",
    description: "Getränkemenge für deine Party berechnen: Bier, Wein, Sekt, Wasser und Softdrinks nach Gästezahl, Dauer und Alkoholanteil.",
    h1: "Getränke für die Party berechnen",
    intro: "Gib Gästezahl, Dauer und den Anteil Alkoholtrinker ein, der Rechner erstellt eine Einkaufsliste mit Bier, Wein, Sekt, Wasser und Softdrinks, inklusive Flaschen und Kästen.",
    faq: [
      { q: "Wie viele Getränke pro Person auf einer Party?", a: "Als Richtwert rechnet man bei einer mehrstündigen Feier rund 1,5 bis 2 Liter pro Person insgesamt, plus etwas Puffer. Der Rechner teilt das je nach Alkoholanteil auf die Getränkearten auf." },
      { q: "Wie viel Bier pro Person?", a: "Pro Bier-Trinker etwa 1 Liter über einen längeren Abend, also rund zwei 0,5-Liter-Flaschen. Bei feierfreudigem Publikum mehr." },
    ],
  },
  {
    slug: "getraenke-hochzeit-berechnen",
    title: "Getränke für die Hochzeit berechnen: Mengen und Einkaufsliste",
    description: "Getränkemenge für die Hochzeit berechnen. Gästezahl und Feierdauer eingeben, Bier, Wein, Sekt, Wasser und Softdrinks als Liste sehen.",
    h1: "Getränke für die Hochzeit berechnen",
    intro: "Eine Hochzeit dauert oft länger, entsprechend mehr Getränke. Gib Gästezahl und Dauer ein, plane den Sektempfang mit ein und du bekommst eine Einkaufsliste mit Puffer.",
    faq: [
      { q: "Wie viel Sekt für den Empfang?", a: "Zum Anstoßen rechnet man etwa ein Glas (0,1 Liter) pro Gast, eine 0,75-Liter-Flasche reicht für 5 bis 7 Gläser." },
    ],
  },
  {
    slug: "wieviel-bier-pro-person",
    title: "Wie viel Bier pro Person? Menge für die Feier berechnen",
    description: "Biermenge pro Person und für die ganze Feier berechnen, mit Flaschen und Kästen, abhängig von Dauer und Gästezahl.",
    h1: "Wie viel Bier pro Person?",
    intro: "Pro Bier-Trinker rechnet man über einen längeren Abend etwa 1 Liter, also rund zwei 0,5-Liter-Flaschen. Stell Gästezahl, Dauer und Bier-Anteil ein, der Rechner zeigt Flaschen und Kästen.",
    faq: [
      { q: "Wie viele Kästen Bier für 30 Personen?", a: "Bei rund 70 % Alkoholtrinkern, davon 60 % Bier, und einem 5-Stunden-Fest sind es grob 1 bis 2 Kästen. Der Rechner gibt dir die genaue Zahl für deine Eingaben." },
    ],
  },
];

export const GETRAENKE_HUB = {
  slug: "getraenkerechner",
  title: "Getränkerechner: Getränkemenge für Party und Feier berechnen",
  description: "Kostenloser Getränkerechner für Party, Hochzeit und Feier. Gästezahl, Dauer und Alkoholanteil eingeben, Einkaufsliste mit Bier, Wein, Sekt, Wasser und Softdrinks erhalten.",
  h1: "Getränkerechner für Feiern",
  faq: [
    { q: "Wie berechne ich die Getränkemenge für eine Feier?", a: "Faustregel: rund 1,5 bis 2 Liter pro Person über einen mehrstündigen Abend, aufgeteilt nach Alkoholtrinkern (Bier, Wein) und allen Gästen (Wasser, Softdrinks), plus 10 % Puffer. Der Rechner macht das automatisch." },
    { q: "Wie viel Wasser und Softdrinks einplanen?", a: "Etwa 0,5 Liter Wasser pro Gast und je nach Anteil Nichttrinker 0,3 bis 0,6 Liter Softdrinks. Für Kinder und an heißen Tagen mehr." },
  ],
};
